<div class="dialogue-content">
  <div class="mat-dialogue-header">
      <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
  </div>
  <mat-dialog-content>
      <div class="text-center">
          <form novalidate>
              <img src="assets/images/verfied.svg" class="mb-4 m-auto d-table" />
              <h5 class="text-primary">Authentication Verified!</h5>
              <p>Your identity has been successfully verified.</p>

             <button matButton="filled" class="btn btn-primary mt-3" (click)="goToDashboard()">Go to Dashboard</button>
              
          </form>
      </div>
  </mat-dialog-content>
</div>